import { Navigate } from 'react-router';

export const Redirect = ({ to }: { to: string }) => {
  return <Navigate to={to} />;
};
